import { FontDisplay } from 'expo-font';

/**
 * Web override of `fonts.ts`. Serves the WOFF2 weights shipped by
 * `@tamagui/font-inter` (~18 KB each) in place of the OTF (~260 KB each)
 * — a ~1 MB → ~72 KB cut across the four weights we load, the dominant
 * "font payload" item in the Lighthouse report. `display: SWAP` shows
 * fallback text immediately and swaps Inter in once the file loads,
 * instead of the default FOIT block.
 */
export const interFontSources = {
  Inter: { uri: require('@tamagui/font-inter/woff2/Inter-Regular.woff2'), display: FontDisplay.SWAP },
  InterBold: { uri: require('@tamagui/font-inter/woff2/Inter-Bold.woff2'), display: FontDisplay.SWAP },
  InterSemiBold: { uri: require('@tamagui/font-inter/woff2/Inter-SemiBold.woff2'), display: FontDisplay.SWAP },
  InterExtraBold: { uri: require('@tamagui/font-inter/woff2/Inter-ExtraBold.woff2'), display: FontDisplay.SWAP },
};
